export default __webpack_public_path__ + "static/media/06__o_1.74ba315f.jpg";